module.exports = __webpack_public_path__ + "img/Weapon_162.fd97e963.png";